import { handleActions } from 'redux-actions';

import loadingStatuses from '@constants/loadingStatuses';
import {
  BillingConciergeAddressType,
  BillingConciergePriceRangeType,
  BillingConciergeType,
} from '@ts/billing-concierge.types';

import {
  setConciergeBillingSubscriptionPriceRangesData,
  setConciergeBillingSubscriptionPriceRangesLs,
  setConciergeBillingData,
  setConciergeBillingLs,
  setConciergeBillingAddressData,
  setConciergeBillingAddressLs,
  setConciergeOrderPriceRangesLs,
  setConciergeOrderPriceRangesData,
} from '@redux/actions/billing-concierge.actions';
import { OrderPricingType } from '@ts/orders.types';

export type ConciergeBillingsStateType = {
  billingDetails: {
    loadingStatus: string;
    data: BillingConciergeType;
  };
  billingPriceRange: {
    loadingStatus: string;
    data: BillingConciergePriceRangeType;
  };
  orderPriceRange: {
    loadingStatus: string;
    data: OrderPricingType[];
  };
  billingAddress: {
    loadingStatus: string;
    data: BillingConciergeAddressType;
  };
};

const initialState: ConciergeBillingsStateType = {
  billingDetails: {
    loadingStatus: loadingStatuses.PENDING,
    data: {
      id: 0,
      balance: 0,
      subscriptionDiscount: 0,
      subscriptionPrice: 0,
      autoRenewal: false,
      nextChargeTime: 0,
      invoiceNumber: '',
      invoiceAmount: 0,
      invoiceChargeTime: 0,
      deactivatedAt: -1,
      paymentExpired: false,
      rejectionLimit: 3,
      card: {
        creditCardNumber: '',
        expirationMonth: '',
        expirationYear: '',
        country: '',
        postalCode: '',
      },
      contactName: '',
      contactEmail: '',
      active: false,
      cancellationReason: '',
    },
  },
  billingPriceRange: {
    loadingStatus: loadingStatuses.PENDING,
    data: {
      itemsList: [],
    },
  },
  orderPriceRange: {
    loadingStatus: loadingStatuses.PENDING,
    data: [],
  },
  billingAddress: {
    loadingStatus: loadingStatuses.PENDING,
    data: {
      addressId: 0,
      companyName: '',
      firstLine: '',
      secondLine: '',
      city: '',
      zipCode: '',
      state: '',
      country: '',
      contactEmail: '',
      contactName: '',
      tax: '',
    },
  },
};

export default handleActions(
  {
    [setConciergeBillingLs]: (state, { payload }) => ({
      ...state,
      billingDetails: {
        ...state.billingDetails,
        loadingStatus: payload,
      },
    }),
    [setConciergeBillingData]: (state, { payload }) => ({
      ...state,
      billingDetails: {
        ...state.billingDetails,
        data: payload,
      },
    }),
    [setConciergeBillingSubscriptionPriceRangesLs]: (state, { payload }) => ({
      ...state,
      billingPriceRange: {
        ...state.billingPriceRange,
        loadingStatus: payload,
      },
    }),
    [setConciergeBillingSubscriptionPriceRangesData]: (state, { payload }) => ({
      ...state,
      billingPriceRange: {
        ...state.billingPriceRange,
        data: payload,
      },
    }),
    [setConciergeOrderPriceRangesLs]: (state, { payload }) => ({
      ...state,
      orderPriceRange: {
        ...state.orderPriceRange,
        loadingStatus: payload,
      },
    }),
    [setConciergeOrderPriceRangesData]: (state, { payload }) => ({
      ...state,
      orderPriceRange: {
        ...state.orderPriceRange,
        data: payload,
      },
    }),
    [setConciergeBillingAddressLs]: (state, { payload }) => ({
      ...state,
      billingAddress: {
        ...state.billingAddress,
        loadingStatus: payload,
      },
    }),
    [setConciergeBillingAddressData]: (state, { payload }) => ({
      ...state,
      billingAddress: {
        ...state.billingAddress,
        data: payload,
      },
    }),
  },
  initialState
);
